import { Injectable } from '@angular/core';


@Injectable({providedIn: 'root'})
export class SettingsValuesService {


  private _SettingsService: any = {};
  private _isInitialized = false;

  public set SettingsService(value: any) {
    this._isInitialized = true;
    this._SettingsService = value;
  }
  public get SettingsService() {
    return this._SettingsService;
  }

  public get isInitialized() {
    return this._isInitialized;
  }

  // Inactivity Timeout in seconds
  public get $inactivityTimeout() {
    return this._SettingsService.$inactivityTimeout;
  }

  public get DateFormat() {
    return this._SettingsService['DateFormat'];
  }
  public get FootprintApi() {
    return this._SettingsService['FootprintApi'];
  }
  public get MongoDb() {
    return this._SettingsService['MongoDb'];
  }
  public get TimeFormat() {
    return this._SettingsService['TimeFormat'];
  }

  public app: SettingsValuesService = this;

  public get FootprintApiManager() {
     return {
DateFormat : this.DateFormat,
FootprintApi : this.FootprintApi,
FootprintApi_ReadOnly : this.FootprintApi,
MongoDb : this.MongoDb,
TimeFormat : this.TimeFormat
    };
  }
  public get Utilities() {
     return {
FootprintApi : this.FootprintApi,
MongoDb : this.MongoDb
    };
  }
  public get Addresses() {
     return {
FootprintApi : this.FootprintApi,
FootprintApi_ReadOnly : this.FootprintApi,
MongoDb : this.MongoDb
    };
  }
  public get Attachments() {
     return {
FootprintApi : this.FootprintApi,
MongoDb : this.MongoDb
    };
  }
  public get Carriers() {
     return {
FootprintApi : this.FootprintApi,
MongoDb : this.MongoDb
    };
  }
  public get Instructions() {
     return {
FootprintApi : this.FootprintApi,
MongoDb : this.MongoDb
    };
  }
  public get SerialNumbers() {
     return {
FootprintApi : this.FootprintApi,
MongoDb : this.MongoDb
    };
  }
  public get Lots() {
     return {
FootprintApi : this.FootprintApi,
MongoDb : this.MongoDb
    };
  }
  public get Owners() {
     return {
FootprintApi : this.FootprintApi,
MongoDb : this.MongoDb
    };
  }
  public get Materials() {
     return {
FootprintApi : this.FootprintApi,
MongoDb : this.MongoDb
    };
  }
  public get Notifications() {
     return {
FootprintApi : this.FootprintApi,
MongoDb : this.MongoDb
    };
  }
  public get DockAppointments() {
     return {
DateFormat : this.DateFormat,
FootprintApi : this.FootprintApi,
MongoDb : this.MongoDb,
TimeFormat : this.TimeFormat
    };
  }
  public get PurchaseOrders() {
     return {
FootprintApi : this.FootprintApi,
FootprintApi_ReadOnly : this.FootprintApi,
MongoDb : this.MongoDb
    };
  }
  public get AsnOrders() {
     return {
FootprintApi : this.FootprintApi,
FootprintApi_ReadOnly : this.FootprintApi,
MongoDb : this.MongoDb
    };
  }
  public get Inventory() {
     return {
FootprintApi : this.FootprintApi,
MongoDb : this.MongoDb
    };
  }
  public get SalesOrders() {
     return {
FootprintApi : this.FootprintApi,
MongoDb : this.MongoDb
    };
  }
  public get Cartonization() {
     return {
FootprintApi : this.FootprintApi,
MongoDb : this.MongoDb
    };
  }
  public get FootprintTestUtilities() {
     return {
FootprintApi : this.FootprintApi,
MongoDb : this.MongoDb
    };
  }
}
